import { Box, useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import HeaderMobile from 'Component/header-mobile';
import { QuestionMarkIcon } from 'Asset/icon';

import DetailOverview from 'View/host-detail/section/detail-overview';
import AchievementLive from 'View/host-detail/section/achievement-live';
import DrawerInfo from 'View/host-detail/section/drawer-info';
import ButtonReschedule from 'View/host-detail/section/button-reschedule';
import RescheduleInfo from 'View/host-detail/section/reschedule-info';

import styles from './styles.module.css';

const HostDetail = () => {
  const { t } = useTranslation('host-schedule');
  const toggleDrawer = useDisclosure();

  return (
    <Box className={styles['host-detail__container']}>
      <HeaderMobile type="header-back" title={t('page.detail')} rightSection={<QuestionMarkIcon onClick={toggleDrawer.onOpen} />} />
      <DetailOverview />
      <AchievementLive />
      <DrawerInfo {...toggleDrawer} />
      <RescheduleInfo />
      <ButtonReschedule />
    </Box>
  );
};

export default HostDetail;
